module.exports = __webpack_public_path__ + "static/img/empty.84ee3439.png";